const quickLinks = [
  { label: 'Sobre o Escritório', href: '#sobre' },
  { label: 'Direito Penal', href: '#areas' },
  { label: 'Direito Previdenciário', href: '#areas' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Contato', href: '#contato' },
];

export default function Footer() {
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    if (href === '#') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ background: '#0A0A0A' }}>
      {/* Main Footer */}
      <div className="py-16 px-6 lg:px-12 border-t border-gold/10" style={{ background: '#0D1B2A' }}>
        <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a href="#" onClick={(e) => handleNav(e, '#')} className="inline-block mb-6 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/bfd915e00effedbd3630bc37231affe4.png"
                alt="Benner Martins Advocacia"
                className="h-14 w-auto object-contain"
              />
            </a>
            <p className="font-sans text-ice/50 text-sm font-300 leading-loose max-w-sm mb-8">
              Atuação jurídica especializada em Direito Penal e Direito Previdenciário, com excelência técnica, ética e comprometimento com os direitos de nossos clientes.
            </p>
            {/* Social */}
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/benner_martins"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gold/25 hover:border-gold/60 rounded-md text-ice/50 hover:text-gold transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href="https://wa.me/5598981578332"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gold/25 hover:border-gold/60 rounded-md text-ice/50 hover:text-gold transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg" />
              </a>
              <a
                href="mailto:bennermartins.adv@gmail.com"
                className="w-10 h-10 flex items-center justify-center border border-gold/25 hover:border-gold/60 rounded-md text-ice/50 hover:text-gold transition-all duration-300 cursor-pointer"
              >
                <i className="ri-mail-line text-lg" />
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h4 className="font-sans text-gold text-xs font-600 tracking-[0.2em] uppercase mb-6">
              <a href="#" className="cursor-pointer">Links Rápidos</a>
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNav(e, link.href)}
                    className="font-sans text-ice/45 hover:text-gold text-sm font-300 transition-colors duration-300 cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-gold/40 text-xs" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-sans text-gold text-xs font-600 tracking-[0.2em] uppercase mb-6">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-gold/60 text-sm mt-0.5" />
                <a href="tel:+5598981578332" className="font-sans text-ice/45 hover:text-gold text-sm font-300 transition-colors duration-300 cursor-pointer">
                  (98) 98157-8332
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-gold/60 text-sm mt-0.5" />
                <a href="mailto:bennermartins.adv@gmail.com" className="font-sans text-ice/45 hover:text-gold text-sm font-300 transition-colors duration-300 cursor-pointer break-all">
                  bennermartins.adv@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-gold/60 text-sm mt-0.5 flex-shrink-0" />
                <span className="font-sans text-ice/45 text-sm font-300 leading-relaxed">
                  Av. dos Holandeses, Ed. Century, Sala 211<br />Calhau — São Luís, MA
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Middle Bar */}
      <div className="py-5 px-6 lg:px-12 border-t border-gold/8 border-b border-gold/8" style={{ background: '#080808' }}>
        <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-3 text-center">
          <span className="font-sans text-ice/20 text-xs font-300">OAB/MA</span>
          <span className="w-px h-3 bg-gold/20" />
          <span className="font-sans text-ice/20 text-xs font-300">Advocacia Ética e Especializada</span>
          <span className="w-px h-3 bg-gold/20" />
          <span className="font-sans text-ice/20 text-xs font-300">São Luís — MA</span>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="py-6 px-6 lg:px-12" style={{ background: '#080808' }}>
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-4 text-center lg:text-left">
          <div className="space-y-1">
            <p className="font-sans text-ice/25 text-xs font-300 leading-relaxed">
              Benner Fernando Ribeiro Martins Sociedade Individual de Advocacia
            </p>
            <p className="font-sans text-ice/20 text-xs font-300">CNPJ: 63.047.257/0001-19</p>
          </div>
          <p className="font-sans text-ice/20 text-xs font-300">
            © 2026 Benner Martins Advocacia. Todos os direitos reservados.
          </p>
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="font-sans text-ice/20 hover:text-gold/60 text-xs font-300 transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            Desenvolvido por Start Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
